import {
  LIST_SCORERS_ROUTE,
  GET_SCORER_ROUTE,
  LIST_SCORES_BY_RUN_ID_ROUTE,
  LIST_SCORES_BY_SCORER_ID_ROUTE,
  LIST_SCORES_BY_ENTITY_ID_ROUTE,
  SAVE_SCORE_ROUTE,
} from '../../handlers/scores';

export const SCORES_ROUTES = [
  LIST_SCORERS_ROUTE,
  GET_SCORER_ROUTE,
  LIST_SCORES_BY_RUN_ID_ROUTE,
  LIST_SCORES_BY_SCORER_ID_ROUTE,
  LIST_SCORES_BY_ENTITY_ID_ROUTE,
  SAVE_SCORE_ROUTE,
] as const;
